import rideApiService from "../../api/raily/ride/ride-api.service";
import RideSolvedRequest from "../../api/raily/ride/solved/ride-solved.request";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import RideSolved from "./solved/ride-solved";
import RideSolvedError from "./solved/ride-solved-error";
import RideSolvedParams from "./solved/ride-solved-params";
import rideSolvedParamsFactory from "./solved/ride-solved-params.factory";
import rideSolvedFactory from "./solved/ride-solved.factory";

const fetchSolvedRides = async (
  params: RideSolvedParams,
  abortSignal: AbortSignal,
): Promise<RideSolved> => {
  const request: RideSolvedRequest = rideSolvedParamsFactory.create(params);

  try {
    const response = await rideApiService().fetchSolvedRides(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return rideSolvedFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | RideSolvedError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const rideService = { fetchSolvedRides };

export default rideService;
